/**
 * @file
 * Builds table rows for HistoricalTable component.
 */

import * as React from 'react';

import { formatMoney, prettifyOunces } from '../../util/util';
import { IHistoricalTableAngler, IHistoricalTableRow } from './types';

/**
 * Format a row for the table in HistoricalTable component.
 */
export const buildHistoricalTableRow = ({
  City,
  final_weight,
  PRIZE_MONEY,
  merchandise_bonus,
  cash_bonus,
  place,
  Title,
  State,
  Water,
  URL,
}: IHistoricalTableAngler): IHistoricalTableRow => ({
  Tournament: (
    <span>
      <a href={URL}>{Title}</a>
      <span> ({Water}) </span>
    </span>
  ),
  // tslint:disable-next-line:object-literal-sort-keys
  Location: (
    <span>
      {City}, {State}
    </span>
  ),
  Place: <span>{place}</span>,
  'Total Weight': <span>{prettifyOunces(final_weight)}</span>,
  'Cash Winnings': <span>{formatMoney(PRIZE_MONEY)}</span>,
  'Merchandise Bonus': <span>{formatMoney(merchandise_bonus)}</span>,
  'Cash Bonus': <span>{formatMoney(cash_bonus)}</span>,
  'Total Money': (
    <span>{formatMoney(merchandise_bonus + cash_bonus + PRIZE_MONEY)}</span>
  ),
});
